/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Events_NewInputs */

const en_features_events_new = /** @type {(inputs: Features_Events_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New event`)
};

const pl_features_events_new = /** @type {(inputs: Features_Events_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowe wydarzenie`)
};

/**
* | output |
* | --- |
* | "New event" |
*
* @param {Features_Events_NewInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_events_new = /** @type {((inputs?: Features_Events_NewInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Events_NewInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_events_new(inputs)
	return en_features_events_new(inputs)
});